<p>frontend-publication-page works!</p>
